<section id="footer" *ngIf="settings$ | async">

    <div class="container-fluid">
        <div class="row footer-sub-menu">
            <div class="col-12 col-lg-3 text-center">
                &copy;{{(settings$ | async).copyText}}
            </div>
            <div class="col-12 col-lg-5 d-flex justify-content-around text-center">
                <a href="https://yorkstonesupplies.co.uk/privacy-policy" target="_blank">Privacy Policy</a>
                <a href="https://yorkstonesupplies.co.uk/cookie-policy" target="_blank">Cookie Policy</a>
                <a href="https://yorkstonesupplies.co.uk/terms-and-conditions" target="_blank">Terms &amp; Conditions</a>
                <a href="https://yorkstonesupplies.co.uk/modern-slavery-policy" target="_blank">Modern Slavery Policy</a>
            </div>
            <div class="col-12 col-lg-4 text-end" style="padding-right: 55px">
                <span *ngIf="(settings$ | async).companyNo">Company registration number {{(settings$ | async).companyNo}}</span>
                <span *ngIf="(settings$ | async).companyNo && (settings$ | async).vatNo" class="ms-2 me-2">|</span>
                <span *ngIf="(settings$ | async).vatNo">Vat number {{(settings$ | async).vatNo}}</span>
            </div>
        </div>
    </div>
</section>

